import dayjs from "dayjs";

// `pattern` is a dayjs format string — pass "MMM D, YYYY" for the compact form
// dense surfaces (cards, chips) use. Default stays the long month.
const formatDate = (value, returnValue = "—", pattern = "MMMM D, YYYY") => {
  if (!value) return returnValue;
  const d = dayjs(value);
  if (!d.isValid()) return returnValue;
  return d.format(pattern);
};

export default formatDate;
